import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import AccountCircle from '@material-ui/icons/AccountCircle';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import SideList from './SideList';
import { connect } from 'react-redux';
import { colors } from '../styles';
import { navigate } from '../actions/routerResolve';
import { setSystem } from '../actions/systemActions';



class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null
        }
    }

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    render() {
        return (
            <div style={styles.root}>
                <AppBar style={{ backgroundColor: colors.primary_darker }} position="static">
                    <Toolbar>
                        <IconButton style={styles.menuButton} color="inherit" aria-label="Menu" onClick={() => this.props.setSystem({ drawer: !this.props.system.drawer })}>
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="title" color="inherit" style={styles.flex}>
                            AIRSHUTTLE
                        </Typography>
                        <Grid>
                            <IconButton
                                color="inherit"
                                onClick={event => this.handleClick(event)}
                                aria-owns={this.state.anchorEl ? 'simple-menu' : null}
                                aria-haspopup="true"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleClose}
                            >
                                <MenuItem onClick={this.handleClose}>Perfil</MenuItem>
                                <MenuItem onClick={() => this.props.logout()}>Logout</MenuItem>
                            </Menu>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <SwipeableDrawer
                    open={this.props.system.drawer}
                    onClose={() => this.props.setSystem({ drawer: false })}
                    onOpen={() => this.props.setSystem({ drawer: true })}
                >
                    <div
                        tabIndex={0}
                        role="button"
                    >
                        <SideList />
                    </div>
                </SwipeableDrawer>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    system: state.systemReducer
})

const mapDispatchToProps = {
    navigate,
    setSystem
};

export default connect(mapStateToProps, mapDispatchToProps)(Header)


const styles = {
    root: {
        flexGrow: 1,
        position: 'fixed',
        zIndex: 2,
        width: '100%'
    },
    flex: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
};


// WEBPACK FOOTER //
// ./src/components/Header.js